import { render, staticRenderFns } from "./occupationImport.vue?vue&type=template&id=d6af144c"
import script from "./occupationImport.vue?vue&type=script&lang=js"
export * from "./occupationImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports